import React from "react";
import styles from "./GetChristmasSorted.module.css";
import GetChristmasSortedForm from "./GetChristmasSortedForm";
function GetChristmasSorted() {
  const dates = [    
    { date: "Wed 11 Nov", time: "3.30 - 5.30pm", location: "Les Ormes" },
    { date: "Wed 11 Nov", time: "6 - 8pm", location: "Les Ormes" },
  ];

  return (
    <div className={styles.GetChristmasSorted}>
      <h2 className={styles.invited}>You're Invited to</h2>
      <h1 className={styles.title}>Get Christmas Sorted</h1>
      <p className={styles.description}>
        A Relaxed 2 hour session to think and plan before starting your
        Christmas shopping
      </p>
      <div className={styles.offering}>
        <div className={styles.offeringLeaveWith}>
          <h2 className={styles.offeringTitle}>You'll Leave With:</h2>
          <ul className={styles.offeringList}>
            <li>Who you're buying for</li>
            <li>Gift ideas for each person</li>
            <li>A budget you're happy with</li>
            <li>A plan ready to take shopping</li>
          </ul>
        </div>
        <div className={styles.offeringDetails}>
          <p className={styles.offeringDetailsText}>
            Take the stress out of Christmas! No preparation needed. We'll work
            it out together, with ideas and personalised help.
          </p>
          <div className={styles.perSession}>Just 12 places per session</div>
        </div>
      </div>
      <div className={styles.pastGuests}>
        <h3>What Past Guests Said</h3>
        <div className={styles.pastGuestQuotes}>
          <div className={styles.pastGuestQuote}>
            <p>
              "It has been really good to have the time & space to think about
              presents early"
            </p>
          </div>
          <div className={styles.pastGuestQuote}>
            <p>"Useful evening Christmas sorted."</p>
          </div>
          <div className={styles.pastGuestQuote}>
            <p>"Good tips for choosing what to gift."</p>
          </div>
        </div>
        <div className={styles.IncludedInSession}>
          <h2 className={styles.includedTitile}>Includes</h2>
          <div className={styles.includedContent}>
            <div className={styles.includedPrice}>
              <div className={styles.value}>£19</div>
              <div className={styles.perPerson}> per person</div>
            </div>
            <div className={styles.includedDetails}>
              <ul className={styles.includedList}>
                <li>2 hour session - worksheet - refreshments</li>
                <li>shop & order personalised gifts</li>
                <li>£10 Match Hampers voucher</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.Dates}>
          {dates.map((date, index) => (
            <div key={index} className={styles.Date}>
              <div className={styles.DateDate}>{date.date}</div>
              <div className={styles.DateTime}>{date.time}</div>
              <div className={styles.DateLocation}>{date.location}</div>
            </div>
          ))}
        </div>
      </div>
        <div className={styles.BookingForm}>
          <GetChristmasSortedForm dates={dates} />
        </div>
    </div>
  );
}

export default GetChristmasSorted;
